import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FileManagerDataService, FilesAndFolders } from './file-manager.service';
import { URL_SERVICE_TOKEN, UrlService } from './folder.service';

@Injectable({
  providedIn: 'root'
})
export class FileManagerDataServiceImpl implements FileManagerDataService {
  public constructor(
    @Inject(URL_SERVICE_TOKEN) private readonly urlService: UrlService,
    private readonly httpClient: HttpClient
  ) {}

  public getSources(rootFolder = ''): Observable<FilesAndFolders> {
    const params = { params: { RootFolder: rootFolder } };
    const url = this.urlService.buildServerApiUrl('khfilemanager');

    return this.httpClient.get<FilesAndFolders>(url, params);
  }

  public upload(folder: string, files: FileList | Blob[]): Observable<HttpEvent<unknown>> {
    const url = this.urlService.buildServerApiUrl('khfilemanager', 'upload');
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    formData.append('folder', folder);

    return this.httpClient.post<unknown>(url, formData, {
      observe: 'events',
      reportProgress: true
    });
  }

  public deleteFolder(folder: string): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('khfilemanager', 'deletefolder');

    return this.httpClient.post<unknown>(url, { folder });
  }

  public deleteFile(fileId: string): Observable<unknown> {
    const url = this.urlService.buildServerApiUrl('khfilemanager/file', fileId);

    return this.httpClient.delete<unknown>(url);
  }
}
